import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="footer-container">
                <div className="footer-brand">
                    <a href="/">
                        <img src="/scrub_logo.png" alt="ScrubMail Logo" className="footer-logo" />
                    </a>
                    <p>ScrubMail – Email verification made easy.</p>
                </div>

                <div className="footer-links">
                    <h4>Product</h4>
                    <Link to="/features">Features</Link>
                    <Link to="/pricing">Pricing</Link>
                    <Link to="/blog">Blog</Link>
                    <Link to="/help">Help</Link>
                </div>

                <div className="footer-links">
                    <h4>Company</h4>
                    <Link to="/privacy">Privacy Policy</Link>
                    <Link to="/terms">Terms of Use</Link>
                    <Link to="/cookie-policy">Cookie Policy</Link>
                    <Link to="/contact">Contact</Link>
                </div>

                <div className="footer-links">
                    <h4>Resources</h4>
                    <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">Payments by Stripe</a>
                    <a href="mailto:support@scrubmail.com">support@scrubmail.com</a>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} ScrubMail. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;